import React, { useState } from 'react';
import { Menu, X, Coffee } from 'lucide-react';

export const SimpleHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleConnectWallet = () => {
    // Safe wallet connection - no automatic MetaMask calls
    if (typeof window !== 'undefined' && window.ethereum) {
      // Only try to connect if user explicitly clicks
      window.ethereum.request({ method: 'eth_requestAccounts' })
        .then((accounts) => {
          console.log('Wallet connected:', accounts[0]);
          // Handle successful connection
        })
        .catch((error) => {
          console.log('User declined wallet connection:', error);
          // Handle user rejection gracefully
        });
    } else {
      // MetaMask not installed
      alert('MetaMask não está instalado. Por favor, instale MetaMask para conectar sua carteira.');
    }
  };

  return (
    <header className="dark-header">
      <div className="flex items-center justify-between w-full">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-blue-600 rounded-lg flex items-center justify-center">
            <Coffee className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold text-primary-text">COFY Token</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <a href="#home" className="dark-nav-link">Início</a>
          <a href="#prices" className="dark-nav-link">Cotações</a>
          <a href="#benefits" className="dark-nav-link">Benefícios</a>
          <a href="#news" className="dark-nav-link">Notícias</a>
          <a href="#invest" className="dark-nav-link">Investir</a>
        </nav>

        <div className="hidden md:block">
          <button 
            onClick={handleConnectWallet}
            className="btn-cta"
          >
            Conectar Wallet
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-primary-text p-2"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-background-dark border-t border-white/10 py-4 z-50">
          <nav className="flex flex-col space-y-4 px-6">
            <a href="#home" className="dark-nav-link" onClick={toggleMenu}>Início</a>
            <a href="#prices" className="dark-nav-link" onClick={toggleMenu}>Cotações</a>
            <a href="#benefits" className="dark-nav-link" onClick={toggleMenu}>Benefícios</a>
            <a href="#news" className="dark-nav-link" onClick={toggleMenu}>Notícias</a>
            <a href="#invest" className="dark-nav-link" onClick={toggleMenu}>Investir</a>
            <button 
              onClick={() => {
                handleConnectWallet();
                toggleMenu();
              }}
              className="btn-cta mt-4 w-full"
            >
              Conectar Wallet
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};